export default "__VITE_ASSET__XWR_YsPT__"